import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import qs from "qs";
import { isEmpty } from 'lodash';
import { Route, Switch, Redirect } from "react-router-dom";
import { ConnectedRouter, routerActions } from 'connected-react-router';
import ErrorBoundary from "./router/ErrorBoundary";
import { loadState } from './redux/helper/local_storage_helper';
import Spinner from './components/spinner';
import { updateUserDetails, registerCampaign, appRedirect } from './modules/phoneAuth/actions';
import { PageView } from './redux/config';
import { FirebaseContext } from "./components/firebase";
import { encrypt } from './redux/helper/cryptojs';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/style.scss';


const PhoneAuth = lazy(() => import('./modules/phoneAuth'));
const Hitmaker = lazy(() => import('./views'));
const page500 = lazy(() => import('./router/page500'));
const Logout = lazy(() => import('./views/logout'));

class App extends Component {
  constructor() {
    super();
    this.state = {
      location: window.location
    };

    this.handleOnSingleSpaRouteChange = this.handleOnSingleSpaRouteChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { dispatch, history: { location: { search } } } = this.props;
    const parsed = qs.parse(search.slice(1));
    const app_user = loadState('app_user');
    if (app_user && app_user?.isDummy === "0") {
      Promise.resolve(dispatch(updateUserDetails(app_user))).then(() => {
        if (!isEmpty(parsed) && parsed.stype) {
          const { stype, campId } = parsed;
          if (campId) {
            registerCampaign(campId, stype)
              .then((res) => {
                if (res.data?.Item) {
                  const { GameType, UserGameId } = res.data.Item;
                  let currGame = parseInt(GameType) === 1 ? 'predict-chart' : (parseInt(GameType) === 2 ? 'music-match' : null);
                  appRedirect(stype, currGame, UserGameId, dispatch);
                }
              })
              .catch(err => {
                console.log("Unable to update user", err);
                dispatch(routerActions.push(`/Hitmaker`));
              });
          } else {
            dispatch(routerActions.push(`/Hitmaker`));
          }
        }
      })
    }
  }

  componentDidMount() {
    // Facebook pixel code
    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        window.fbq('track', 'PageView');
      }
    }
    // Log page view
    PageView();

    window.addEventListener('single-spa:routing-event', this.handleOnSingleSpaRouteChange);
  }

  componentWillUnmount() {
    window.removeEventListener('single-spa:routing-event', this.handleOnSingleSpaRouteChange);
  }

  handleOnSingleSpaRouteChange() {
    this.setState({ location: window.location });
  }

  render() {
    const { history } = this.props;
    const app_user = loadState('app_user');
    return (
      <ErrorBoundary>
        <ConnectedRouter history={history}>
          <FirebaseContext.Consumer>
            {
              firebase => {
                return (
                  <Suspense fallback={<Spinner />}>
                    <Switch location={this.state.location}>
                      <Route
                        exact
                        path={'/login'}
                        name={'login'}
                        render={(props) => {
                          if (!app_user || app_user?.isDummy === "1") {
                            return <PhoneAuth {...props} firebase={firebase} />
                          } else {
                            return <Redirect to={'/Hitmaker'} />
                          }
                        }}
                      />
                      <Route
                        path="/logout"
                        name="logout"
                        exact
                        render={props => <Logout {...props} />}
                      />
                      <Route path='/500' component={page500} />
                      <Route
                        path={'/Hitmaker/:pbi?'}
                        render={(props) => <Hitmaker {...props} />}
                      />
                      <Route
                        path='/'
                        render={() => <Redirect to={`/Hitmaker/bonus?mode=${encrypt("start")}&userGameId=${encrypt(0)}&playFor=${encrypt('menu')}`} />}
                      />
                    </Switch>
                  </Suspense>
                )
              }
            }
          </FirebaseContext.Consumer>
        </ConnectedRouter>
      </ErrorBoundary>
    );
  }
}

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object,
  pathname: PropTypes.string.isRequired
};

const mapStateToProps = ({ router }) => {
  const { location: { pathname } } = router;
  return {
    pathname
  }
}

export default connect(mapStateToProps)(App);
